const TrcInitialCellMapping = {
	input: {
		buildingType: "Initial!B3",
		operationType: "Initial!B4",
		totalAmountInclVat: "Initial!B5",
		existingWarrantyRate: "Initial!B6",
		constructionPeriod: "Initial!B7",
		brokerCommission: "Initial!B10",
		brokerMinCommission: "Initial!B11",
		brokerFees: "Initial!B12",
	},
	output: {
		damageCoveragePrimeHT: {
			cellReference: "Initial!F3",
			outputType: "price",
		},
		damageCoveragePrimeTaxes: {
			cellReference: "Initial!G3",
			outputType: "price",
		},
		damageCoveragePrimeTTC: {
			cellReference: "Initial!H3",
			outputType: "price",
		},
		damageCoverageFirePrimeHT: {
			cellReference: "Initial!F4",
			outputType: "price",
		},
		damageCoverageFirePrimeTaxes: {
			cellReference: "Initial!G4",
			outputType: "price",
		},
		damageCoverageFirePrimeTTC: {
			cellReference: "Initial!H4",
			outputType: "price",
		},
		damageCoverageOtherDamagesPrimeHT: {
			cellReference: "Initial!F5",
			outputType: "price",
		},
		damageCoverageOtherDamagesPrimeTaxes: {
			cellReference: "Initial!G5",
			outputType: "price",
		},
		damageCoverageOtherDamagesPrimeTTC: {
			cellReference: "Initial!H5",
			outputType: "price",
		},
		damageCoverageNaturalDisastersPrimeHT: {
			cellReference: "Initial!F6",
			outputType: "price",
		},
		damageCoverageNaturalDisastersPrimeTaxes: {
			cellReference: "Initial!G6",
			outputType: "price",
		},
		damageCoverageNaturalDisastersPrimeTTC: {
			cellReference: "Initial!H6",
			outputType: "price",
		},
		rcmoPrimeHT: {
			cellReference: "Initial!F7",
			outputType: "price",
		},
		rcmoPrimeTaxes: {
			cellReference: "Initial!G7",
			outputType: "price",
		},
		rcmoPrimeTTC: {
			cellReference: "Initial!H7",
			outputType: "price",
		},
		terrorismContributionPrimeHT: {
			cellReference: "Initial!F8",
			outputType: "price",
		},
		terrorismContributionPrimeTaxes: {
			cellReference: "Initial!G8",
			outputType: "price",
		},
		terrorismContributionPrimeTTC: {
			cellReference: "Initial!H8",
			outputType: "price",
		},
		duneManagementFeesHT: { cellReference: "Initial!F9", outputType: "price" },
		duneManagementFeesTaxes: {
			cellReference: "Initial!G9",
			outputType: "price",
		},
		duneManagementFeesTTC: { cellReference: "Initial!H9", outputType: "price" },
		intermediaryManagementFeesHT: {
			cellReference: "Initial!F10",
			outputType: "price",
		},
		intermediaryManagementFeesTaxes: {
			cellReference: "Initial!G10",
			outputType: "price",
		},
		intermediaryManagementFeesTTC: {
			cellReference: "Initial!H10",
			outputType: "price",
		},
		totalClientPrimeHT: { cellReference: "Initial!F11", outputType: "price" },
		totalClientPrimeTaxes: {
			cellReference: "Initial!G11",
			outputType: "price",
		},
		totalClientPrimeTTC: { cellReference: "Initial!H11", outputType: "price" },

		agreedRateHT: { cellReference: "Initial!F13", outputType: "percentage" },
		agreedRateTTC: { cellReference: "Initial!F14", outputType: "percentage" },

		brokerCommission: { cellReference: "Initial!F16", outputType: "price" },
		brokerRemuneration: { cellReference: "Initial!F17", outputType: "price" },
		totalClientPrimeWithoutBrokerRemuneration: {
			cellReference: "Initial!F18",
			outputType: "price",
		},

		duneNetCommission: { cellReference: "Initial!F20", outputType: "price" },
		duneNetRemuneration: { cellReference: "Initial!F21", outputType: "price" },
	},
};

export { TrcInitialCellMapping };
